export default __webpack_public_path__ + "static/media/330_dummy2016-sportbekleidung01-mobile-de.58ada163.png";